// src/helpers/collections.ts
function nonNull(val) {
  return val !== null && val !== void 0;
}
export {
  nonNull
};
//# sourceMappingURL=collections.mjs.map